<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>任务管理 > <b>视频列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
            <span class="search_span_width">
                <span class="search_span_width_part1">分类：</span>
				 <Select v-model="search.studio_type" style="width:100px">
				        <Option value="2" :key="2">直播</Option>
						<Option value="1" :key="1">视频</Option>
						<Option value="10" :key="10">链式视频</Option>
				</Select>
            </span>
			<span class="search_span_width">
				<span class="search_span_width_part1">客户：</span>
				<Select style="width:100px"
					 v-model="search.user_id"
					 filterable
					 clearable
					 :remote-method="userlist"
					 :loading="loading2">
					 <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.mobile}}</Option>
				</Select>
			</span>
			<span class="search_span_width">
				    <span class="search_span_width_part1">&nbsp;&nbsp;直播视频名称：</span>
				  <Input v-model="search.name" placeholder="请输入直播视频名称" clearable :style="{'width':'110px'}"></Input>
			</span>
			<span class="search_span_width">
				    <span class="search_span_width_part1">&nbsp;&nbsp;人物ID：</span>
				  <Input v-model="search.figure_id" placeholder="人物ID" clearable :style="{'width':'80px'}"></Input>
			</span>
			<span class="search_span_width">
				    <span class="search_span_width_part1">&nbsp;&nbsp;声音ID：</span>
				  <Input v-model="search.spk_id" placeholder="声音ID" clearable :style="{'width':'80px'}"></Input>
			</span>
      <span class="search_span_width">
        <span class="search_span_width_part1">&nbsp;&nbsp;直播间ID：</span>
        <Input v-model="search.id" placeholder="声音ID" clearable :style="{'width':'80px'}"></Input>
			</span>
			<span class="search_span_width">
			    <span class="search_span_width_part1">状态：</span>
				 <Select v-model="search.status" style="width:100px">
				        <Option value="0" :key="0">全部</Option>
						<Option value="1" :key="1">视频生成中</Option>
						<Option value="2" :key="2">视频生成成功</Option>
						<Option value="3" :key="3">视频生成失败</Option>
						<Option value="4" :key="4">语音生成中</Option>
						<Option value="5" :key="5">语音生成失败</Option>
						<Option value="6" :key="6">语音生成成功</Option>
				</Select>
			</span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getStudioList()">搜索</Button>
      </Card>
	<Card id="tableContent" >
	  <Table :columns="tableColumns" :data="studio_list"></Table>
	  <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getStudioList"/>
	  
	</Card>
    </Content>
	<Modal v-model="videomodal"  title="生成视频" width="900" :footer-hide=true>
    <Collapse style="margin-bottom: 20px;">
      <Panel name="1">
        生产信息
        <template #content>
          <b>请求：</b>
          <pre class="response-content">
            <span v-if="video_list && video_list.detail && video_list.detail.prod.request">
              {{video_list.detail.prod.request}}
            </span>
          </pre>
          <Divider />
          <b>响应：</b>
          <pre class="response-content">
            <span v-if="video_list && video_list.detail && video_list.detail.prod.response">
              {{JSON.parse(video_list.detail.prod.response)}}
            </span>
          </pre>
        </template>
      </Panel>
      <Panel name="2">
        回调信息
        <template #content>
          <b>请求：</b>
          <pre class="response-content">
            <span v-if="video_list && video_list.detail && video_list.detail.callback && video_list.detail.callback.request">
              {{video_list.detail.callback.request}}
            </span>
          </pre>
          <Divider />
          <b>响应：</b>
          <pre class="response-content">
            <span v-if="video_list && video_list.detail && video_list.detail.callback && video_list.detail.callback.response">
              {{JSON.parse(video_list.detail.callback.response)}}
            </span>
          </pre>
        </template>
      </Panel>
    </Collapse>
		 <video :src="video_list.figure_video" width="33%"  controls />
		 <video :src="video_list.final_video" width="33%"  controls />
<!--		 <video :src="video_list.final_video1" width="33%"  controls />-->
	</Modal>
    <!-- modal - 语音列表 -->
    <Modal v-model="showVoiceModal" title="语音列表" cancel-text="" class-name="voice-list-modal" @on-visible-change="closeVoiceModal" width="1200">
      <div>
        <List  border style="margin-bottom: 15px;">
          <ListItem>{{ shellContent }}</ListItem>
        </List>
      </div>
      <div>
          <Table :columns="speakColumns" :data="speakData"></Table>
      </div>
      <Page
          :total=voiceData.total
          :current=voiceData.page
          :page-size=voiceData.pagesize
          :show-elevator="true"
          show-total
          class="common-page"
          @on-change="ajaxGetVoice"

      />
      <template #footer>
        <Button type="success" @click="regenerateSubtitles">重新生成字幕</Button>
      </template>
    </Modal>
    <Modal
        v-model="showFailDetail"
        title="失败详情"
        footer-hide>
      <div>
        <span>失败原因</span>
        <List  border style="margin-bottom: 15px;">
          <ListItem>{{failedInfo.fail_reason}}</ListItem>
        </List>
      </div>
      <div>
        <span>失败详情</span>
        <List  border style="margin-bottom: 15px;">
          <ListItem>{{failedInfo.fail_detail}}</ListItem>
        </List>
      </div>
    </Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			studio_type:'1',
			tag_id:0,
			status:'',
			user_id:0,
			name:'',
			figure_id:0,
			spk_id:0,
      id:0
		},
		showmodal:false,
		videomodal:false,
		recordTotal:0,
    loading2:false,
    showFailDetail:false,
		page:1,
		studio_list:[],
		video_list:[],
		user_list:[],
    audioId:0,
    showVoiceModal: false,
    shellContent:"",
    voiceData: {
      id: '',
      list: [],
      page: 1,
      pagesize: 10,
      total: 0,
      errMsg: ''
    },
    speakForm:{
      studio_id:""
    },
    failedInfo:{
      fail_reason:"",
      fail_detail:""
    },
		tableColumns:[
		{ title: '直播间ID', key: 'id', align: 'center',width:'160px' },
		{ title: '名称', key: 'name', align: 'center' ,width:'160px'},
		{ title: '用户ID', key: 'user_id', align: 'center',width:'160px' },
		{ title: '人物ID', key: 'figure_id', align: 'center',width:'160px' },
		{ title: '声音ID', key: 'spk_id', align: 'center',width:'160px' },
		{ title: '封面', key: 'cover', align: 'center',width:'160px',
		render:(h,params) =>{
		   return h('img',{
			 attrs : {src : params.row.cover},
			 style : { width : '80px', height : '80px' }
		   })
		}},
		{ title: '类型', key: 'studio_type', align: 'center',width:'160px',
			render: (h, params) => {
				var txt = '';
				if (params.row.studio_type =='1') {
					txt = '视频';
				} else if (params.row.studio_type =='2') {
					txt = '直播';
				} else if (params.row.studio_type =='3') {
					txt = '小程序视频';
				} else if (params.row.studio_type =='4') {
					txt = '智能成片';
				}else if (params.row.studio_type =='7') {
					txt = '接口模板视频';
				} else if (params.row.studio_type =='8') {
					txt = '一键成片';
				} else if (params.row.studio_type =='10') {
					txt = '链式视频';
				}
				return h("div",{},txt);
			}
		},
		{ title: '生成状态', key: 'status', align: 'center',width:'160px',
			render: (h, params) => {
				var txt = '';
				if (params.row.status =='0') {
					txt = '未生成';
				} else if (params.row.status =='1') {
					txt = '视频生成中';
				} else if (params.row.status =='2') {
					txt = '视频生成成功';
				} else if (params.row.status =='3') {
					txt = '视频生成失败';
				} else if (params.row.status =='4') {
					txt = '语音生成中';
				} else if (params.row.status =='5') {
					txt = '语音生成失败';
				} else if (params.row.status =='6') {
					txt = '语音生成成功';
				}
				
				return h("div",{},txt);
			}
		},
		{ title: '使用模板', key: 'copy_id', align: 'center',width:'160px' },
        { title: '消耗时长', key: 'duration', align: 'center' ,width:'160px'},
		{ title: '创建时间', key: 'created_at', align: 'center',width:'160px' },
		{ title: '更新时间(成功状态为生成时间)', key: 'updated_at', align: 'center',width:'160px' },
		{ title: '操作', key: 'action',fixed: 'right',  align: 'center',width:'160px',
		  render: (h, params) => {
			let btns=[]
			btns.push(
			  h('Button', {
				props: { type: 'success', size: 'small' },
				style: { marginRight: '5px', marginBottom: '5px'},
				on: {
				  click: () => {
					this.shellContent = ""
					this.showVoiceModal = true;
					this.speakForm.studio_id = params.row.id

					this.voiceData.id = params.row.id
					this.voiceData.page =
					this.voiceData.errMsg = ''
					this.voiceData.list = []
					this.voiceData.total = 0

					this.ajaxGetVoice(1);
				  }
				}
			  }, '脚本+语音'),
			);

			
			btns.push(
				h('Button', {
				  props: { type: 'error', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {      
						this.reCreate(params.row.id, 1);
					}
				  }
				}, '重新生成语音'),
			);
			
			if (params.row.status == 3 || params.row.status==1) {
				btns.push(
					h('Button', {
					  props: { type: 'error', size: 'small' },
					  style: { marginRight: '5px', marginBottom: '5px'},
					  on: {
						click: () => {      
							this.reCreate(params.row.id, 2);
						}
					  }
					}, '重新生成视频'),
				);
			}
      if (params.row.status == 3) {
        btns.push(
            h('Button', {
              props: { type: 'primary', size: 'small' },
              style: { marginRight: '5px', marginBottom: '5px'},
              on: {
                click: () => {
                  this.failedInfo={}
                  this.getStudioFailedInfo(params.row.id)

                }
              }
            }, '失败原因'),
        );
      }
			if ((params.row.status == 2 || params.row.status == 3) && params.row.studio_type!=2) {
				btns.push(
					h('Button', {
					  props: { type: 'info', size: 'small' },
					  style: { marginRight: '5px', marginBottom: '5px'},
					  on: {
						click: () => {      
							this.reCreate(params.row.id, 3);
						}
					  }
					}, '重新渲染'),
				);
			}
			if (params.row.status == 2 && params.row.studio_type!=2) {
				btns.push(
					h('Button', {
					  props: { type: 'success', size: 'small' },
					  style: { marginRight: '5px', marginBottom: '5px'},
					  on: {
						click: () => {      
							this.getVideoList(params.row.id);
						}
					  }
					}, '查看视频'),
				);
			}

			return h("div",btns);
		  }
		}
		],
    speakColumns:[
      {
        type: 'expand',
        width: 50,
        render: (h,  params) => {
          return h('div', params.row.revised_subtitles)
        }
      },
	  { title: 'id', key: 'id', align: 'center'},
      { title: '内容', key: 'content', align: 'center'},
      { title: '状态', key: 'voice_status', align: 'center',width:150, render: (h, params) => {
          let status = ""
          if(params.row.voice_status==1){
            status = "生成中";
          }
          if(params.row.voice_status==2){
            status = "成功";
          }
          if(params.row.voice_status==-1){
            status = "失败";
          }
          if(params.row.voice_status== -2){
            status = "失败有敏感词";
          }
          return h('span', status)
        }
      },
      { title: '操作', key: 'action', align: 'center',width:150, render: (h, params) => {
          let btns=[]
          if(params.row.voice){
            btns.push(
                h('Button', {
                  props: { type: 'success', size: 'small' },
                  on: {
                    click: () => {
                      this.tryListenHandle(params.row.voice, params.row.id)
                    }
                  }
                }, '播放'),
            );

          }else{
            btns.push(
                h('Button', {
                  props: { type: 'default', size: 'small' },
                  style:{disabled:true},
                  on: {
                    click: () => {
                    }
                  }
                }, '暂时无法播放'),
            );
          }
          return h("div",btns);
        }
      },
    ],
    speakData:[

    ],
    trackColumns:[
      {
        title: 'Name',
        key: 'name'
      },
      {
        title: 'Age',
        key: 'age'
      },
    ]
	}
  },
  mounted:function(){
    this.getStudioList();
  },
  computed:{
	
  },
  methods:{
	userlist(query){
	if (query !== '' && query.length==11) {
		this.loading2 = true;
		setTimeout(() => {
			this.loading2 = false;

			this.http.get('/admin/user/userList',{params:{mobile:query}}).then(response=>{
			  let data=response.data;
			  if(data.code!==0)
			  {
				alert(data.message);
			  } else{
				this.user_list = data.data.list;
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});

		}, 200);
	}
	},
	getStudioList(page = this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/studio/studioList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.studio_list = data.data.studio_list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getStudioContent(studio_id){
		this.http.get('/admin/studio/studioContent',{params:{studio_id:studio_id}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.$Modal.confirm({
				title: '脚本内容',
				content: '<p>'+data.data+'</p>'
			});
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
  reRender(studio_id){
    this.$Modal.confirm({
      content: '<p>确定重新渲染？</p>',
      onOk: () => {
        this.http.post('/admin/studio/reRender',{studio_id:studio_id}).then(response=>{
          let data=response.data;
          if(data.code!==0) {
            this.$Message.error(data.message);
            return false;
          } else{
            this.$Message.success(data.message);
            return true;
          }
        });
      },
      onCancel: () => {
      }
    });

  },
	getVideoList(studio_id) {
		this.http.get('/admin/studio/videoList',{params:{studio_id:studio_id}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.video_list = data.data;
			this.videomodal = true;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');``
		});
	},
	reCreate(studio_id,retype) {
		this.http.get('/admin/studio/reCreate',{params:{studio_id:studio_id,retype:retype}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.$Message.info('已提交重试');
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
    /**
     * @desc 获取语音列表
     */
  ajaxGetVoice (page, rowData) {
    this.voiceData.page = page || 1
    console.log(this.voiceData)

    this.http.get('/admin/studio/studioContent',{params:{studio_id:this.voiceData.id}}).then(response=>{
      let data=response.data;
      if(data.code!==0){
        alert(data.message);
      } else{
        this.shellContent = data.data
      }
    }).catch(()=>{
      this.$Message.error('网络错误');
    });

    this.http.get('/admin/studio/failVoice', {
      params: {
        studio_id: this.voiceData.id,
        page: this.voiceData.page,
        pagesize: this.voiceData.pagesize
      }
    }).then(response => {
      let data = response.data
      if (data.code !== 0){
        this.voiceData.list = []
        this.voiceData.errMsg = data.message
      } else{
        this.voiceData.list = []
        this.voiceData.total = 0
        this.voiceData.errMsg='暂无数据'

        if(data.data && data.data.list){
          this.voiceData.list = data.data.list
          this.speakData = data.data.list;
        }
        if(data.data && data.data.total){
          this.voiceData.total = data.data.total
        }
        if(data.data.total>0){
          this.voiceData.errMsg=""
        }
      }
      // this.voiceData.loading = false
    }).catch(err => {
      this.voiceData.list = []
      this.voiceData.errMsg = err.message
      this.voiceData.loading = false
    });
  },
    /**
     * @desc 关闭语音列表
     */
    closeVoiceModal (e) {
      if (!e) {
        this.voiceData.loading = false
        this.audioObj && this.audioId && this.audioObj.pause()
      }
    },

    /**
     * @desc 试听
     */
    tryListenHandle (url, id) {
      if (!url) return

      if (!this.audioObj) {
        this.audioObj = document.createElement("audio")
        this.audioObj.className = 'audio-play'
        document.body.append(this.audioObj)
        this.audioObj.controls = true
        this.audioObj.style.position = 'fixed'
        this.audioObj.style.opacity = 0

        this.audioObj.addEventListener('play', () => {}, false)

        this.audioObj.addEventListener('ended', () => {
          this.audioId = ''
        }, false)

        this.audioObj.addEventListener('pause', () => {
          this.audioId = ''
        }, false)
      }

      if (this.audioId == id) {
        this.audioObj.pause()
      } else {
        this.audioId = id
        this.audioObj.src = url
        this.audioObj.play()
      }
    },
    // 重新生成字幕
    regenerateSubtitles(){
      this.http.get('/admin/studio/regenerateSubtitles',{params:{studio_id:this.speakForm.studio_id}}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.$Message.info('已创建重新生成字幕任务');
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    getStudioFailedInfo(studioId){
      this.http.get('/admin/studio/getStudioFailedInfo',{params:{studio_id:studioId}}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.failedInfo.fail_detail = data.data.fail_detail
          this.failedInfo.fail_reason = data.data.fail_reason
          this.showFailDetail = true;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    }

  }
}
</script>

<style scoped>
.voice-list-modal .voice-list-item.voice-createing {
  color: #aaa508;
}
.voice-list-modal .voice-list-item.voice-list-item-pointer {
  cursor: pointer;
}
.response-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
</style>
